export default __webpack_public_path__ + "static/media/image 12.c8180e30.png";